import React from 'react';
import api from 'services';
import AutoComplete from 'material-ui/AutoComplete';

import {orange500} from 'material-ui/styles/colors';

class PortOfRegistry extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            ports: [],
            homePortObject: props.homePortObject,
        };

        this.changeAutoCompete = this.changeAutoCompete.bind(this);
        this.chooseAutoComplete = this.chooseAutoComplete.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            homePortObject: nextProps.homePortObject,
        });
    }

    changeAutoCompete(searchText) {
        this.props.changeAutoComplete('homePort', { name: searchText, _id: '' });
        this.setState({
            homePortObject: {
                name: searchText,
                _id: '',
            },
        }, () => {
            const { homePortObject: { name }} = this.state;

            if (name.length < 2) {
                return;
            }

            api.findPortAdmin({ name })
                .then((response) => {
                    if (response.status === 200) {
                        const ports = response.data.data.map((port) => {
                            return {
                                name: port.country ? `${port.name}, ${port.country.name}` : port.name,
                                port,
                            };
                        });

                        this.setState({
                            ports,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error AutoComplete ports - port of registry', error);

                    return null;
                });
        });

    }

    chooseAutoComplete(updateProperties) {
        this.setState({
            homePortObject: updateProperties.port,
        }, () => {
            this.props.changeAutoComplete('homePort', updateProperties.port);
        });
    }

    render() {
        const { ports, homePortObject } = this.state;
        const { getError, confirmed, modifiedFields, underStyle } = this.props;

        return (
            <AutoComplete
                name='homeport'
                disabled={confirmed}
                floatingLabelText='Port of registry'
                searchText={homePortObject.name}
                dataSource={ports}
                dataSourceConfig={{ text: 'name', value: 'port' }}
                onUpdateInput={this.changeAutoCompete}
                onNewRequest={this.chooseAutoComplete}
                filter={AutoComplete.noFilter}
                errorText={getError('homePort')}
                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                popoverProps={{
                    canAutoPosition: true,
                }}
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('homePort') ? underStyle : null}
            />
        );
    }
}

export default PortOfRegistry;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/PortOfRegistry.jsx